import {
  Create,
  SimpleForm,
} from "react-admin";
import {
  ActionTitles,
  RESOURCES,
  RESOURCES_BASEPATH,
} from "../Constants";
import ListActions from "../common/ListActions";
import { contentCenter, simpleForm } from "../Styles";
import { ReportThemeFormGrid } from "./ReportThemeFormGrid";
import { Toolbar } from "./ReportThemeToolbar";
import { useState } from "react";

export const ReportThemeCreate = () => {

  const [configurationPresent, setConfigurationPresent] = useState(false);
  
  return (
    <Create
      actions={
        <ListActions
          title={ActionTitles.REPORT_THEME_CREATE}
          renderButtonAndSearch={false}
          mutationMode="pessimistic"          
        />
      }
      sx={contentCenter}
    >
      <SimpleForm
        warnWhenUnsavedChanges
        toolbar={
					<Toolbar						
						buttonTitle={ActionTitles.CREATE}
						basePath={RESOURCES_BASEPATH.REPORT_THEME}
						resource={RESOURCES.REPORT_THEME}
            isEdit={false}
            disabled={configurationPresent}
					/>
				}
        mode="onBlur"
        reValidateMode="onBlur"
        sx={simpleForm}
      >
        <ReportThemeFormGrid
          isEdit={false}
          configurationPresent={configurationPresent}
          setConfigurationPresent={setConfigurationPresent}
        />
      </SimpleForm>      
    </Create>
  );
};